import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-confirmation-dialog',
  templateUrl: './change-confirmation-dialog.component.html',
  styleUrls: ['./change-confirmation-dialog.component.scss']
})
export class ChangeConfirmationDialogComponent implements OnInit {

  public title: string;
  public description: string;
  public subText: string;
  public descriptionSecondParagraph: string;
  public okButtonText: string = 'default.ok';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeConfirmationDialogComponent>) { }

  public ngOnInit(): void {
    // Hardcode width to keep confirmation dialogs tidy and consistent
    this.dialogRef.updateSize('480px');

    this.title = this.data.title;
    this.description = this.data.description;
    this.subText = this.data.subText;
    this.descriptionSecondParagraph = this.data.descriptionSecondParagraph;
    if (this.data.okButtonText) {
      this.okButtonText = this.data.okButtonText;
    }

    if (this.data.descriptionArray) {
      if (this.description === undefined) {
        this.description = '';
      }
      for (let i = 0; i < this.data.descriptionArray.length; i++) {
        const text = this.data.descriptionArray[i];
        this.description = `${this.description} ${text}`;
      }
    }

  }

  /**
   * Return true
   */
  public confirm(): void {
    this.dialogRef.close(true);
  }

  /**
   * Return false
   */
  public cancel(): void {
    this.dialogRef.close(undefined);
  }

}
